<template>
  <div class="GradeOptions">
    <!-- <h4>Grades</h4> -->
    <ul class="left">
      <li v-for="(filter,index) in gradeFilters.slice(0, 9)" :key="'gradefilter-a-' + index"><CheckInput :key="'checkInput-gradefilter-a-' + index" :item="filter"/></li>
    </ul>

    <ul class="right">
      <li v-for="(filter,index) in gradeFilters.slice(9)" :key="'gradefilter-b-' + index"><CheckInput :key="'checkInput-gradefilter-b-' + index" :item="filter"/></li>
    </ul>
  </div>
</template>

<script>
import CheckInput from '@/components/CheckInput'
export default {
  name: 'GradeOptions',
  components: { CheckInput },
  data () {
    return {
    gradeFilters: [
        {
          name: 'K',
          shortname: 'k',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '1',
          shortname: '1',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '2',
          shortname: '2',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '3',
          shortname: '3',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '4',
          shortname: '4',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '5',
          shortname: '5',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '6',
          shortname: '6',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '7',
          shortname: '7',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '8',
          shortname: '8',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '9',
          shortname: '9',
          filterId: 0,
          resultsCount: null,
          kind: "grades",
        },
        {
          name: '10',
          shortname: '10',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '11',
          shortname: '11',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: '12',
          shortname: '12',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: 'College/University',
          shortname: 'college',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: 'Educator',
          shortname: 'educator',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
        {
          name: 'Adult',
          shortname: 'adult',
          filterId: 0,
          resultsCount: null,
          kind: "grades"
        },
      ],
    }
  }
};
</script>

<style scoped lang="scss">
.GradeOptions {
  overflow: hidden;
  padding-top: 30px;
  padding-left: 15px;

  ul.left, ul.right {
    width: 50%; float: left;

    li {
      width: 100%;
    }
  }
}
</style>
